export const DATE_PICKER_LOADING_CLASS = 'wc-bookings-date-picker--loading';

const pendingRequests = new WeakMap();

/**
 * Prevent interaction with a date picker until an availability request finishes.
 *
 * @since 3.12.0
 *
 * @param {HTMLElement} picker  Inner date picker element.
 * @param {Object}      request jQuery AJAX request.
 * @return {Object} The tracked request.
 */
export const lockDatePickerForRequest = ( picker, request ) => {
	const datePicker = picker?.closest( '.wc-bookings-date-picker' );

	if ( ! datePicker ) {
		return request;
	}

	const count = pendingRequests.get( datePicker ) || 0;
	pendingRequests.set( datePicker, count + 1 );
	datePicker.classList.add( DATE_PICKER_LOADING_CLASS );
	datePicker.setAttribute( 'aria-busy', 'true' );
	picker.setAttribute( 'inert', '' );

	request.always( () => {
		const remaining = pendingRequests.get( datePicker ) - 1;
		if ( remaining ) {
			pendingRequests.set( datePicker, remaining );
			return;
		}

		pendingRequests.delete( datePicker );
		datePicker.classList.remove( DATE_PICKER_LOADING_CLASS );
		datePicker.removeAttribute( 'aria-busy' );
		picker.removeAttribute( 'inert' );
	} );

	return request;
};
